module.exports = __webpack_public_path__ + "static/media/mulher_r1_c1.79f79074.jpg";